import { Listbox } from "@headlessui/react"
import { ChevronDown } from "lucide-react"

import { If } from "../ui"
import { SelectOption } from "../../types"

export const findSelectedOption = (
  options: { id: string; name: string }[],
  value: string
) => options?.find(opt => opt.id === value)

export const findSelectOptionName = (
  id: string | number,
  options: SelectOption[]
) => options.find(item => item.id === id)?.name

export const findSelectOptionId = (name: string, options: SelectOption[]) => {
  return options.find(item => item.name === name)?.id
}

export const getSelectedOptionHTML = (
  selected: any,
  buttonClassName: string,
  multiple?: boolean,
  isLoading?: boolean,
  selectedLabel?: string
) => (
  <Listbox.Button
    className={`relative w-full cursor-pointer rounded-md border border-neutral-200 p-3 pr-10 text-left shadow-sm focus:border-primary-400 focus:outline-none focus:ring-1 focus:ring-primary-400 sm:text-sm ${buttonClassName}`}
  >
    <span className="block truncate">
      {multiple && (selected?.length ? selected.join(", ") : "-")}{" "}
      {!multiple && (
        <>
          {selected?.icon && (
            <span className="flex items-center">
              <span className="pr-2">{selected.icon}</span>
              <span className="font-medium text-sm md:text-base">
                {selected.name}
              </span>
            </span>
          )}
          {!selected?.icon && (selectedLabel ?? "-")}
        </>
      )}
    </span>
    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
      <If
        loaderSize={6}
        isLoading={isLoading}
        condition
        then={
          <ChevronDown className="h-5 w-5 text-gray-400" aria-hidden="true" />
        }
      />
    </span>
  </Listbox.Button>
)
